export const scenesTitles = [
  'scene1',
  'scene2',
  'scene3',
  'scene4',
  'scene5',
  'scene6',
  'scene7',
];
export const sceneNamePrefix = 'scene_';
export const scenes = Object.fromEntries(scenesTitles.map((scene, i)=>[sceneNamePrefix+(i+1),null]));
export const threshold = 0.0002;
export const audios = {
  global: []
}

window.currentScene = 0;
window.carIsMoving = true;
window.audioEnabled = false;
